import './header.css'
import data from './data'
import HeaderImage from '../../assets/IMG_0213.JPG'
import AOS from '@reimujs/aos';
import "@reimujs/aos/dist/aos.css";
import { useEffect } from 'react';

const Header = () => {

  useEffect(() => {
    AOS.init({duration:2000});
  })

  return (
    <header id="home">
      <div className="container header__container">
        <div className="header__profile" data-aos="fade-in" >
          <img src={HeaderImage} alt="Header Portrair" />
        </div>
        <h3 data-aos="fade-up">Enes Chatzi Osman</h3>
        <h5 data-aos="fade-up">Java & Spring Boot Developer</h5>
        <p data-aos="fade-up">Computer Engineer with a background in IT Support and backend application development</p>
        <div className="header__cta" data-aos="fade-up">
          <a href="#contact" className='btn primary'>Let's Talk</a>
          <a href="#portfolio" className='btn light'>My Projects</a>
        </div>
        <div className="header__socials">
          {
            data.map(item => <a key={item.id} href={item.link} target='_blank' 
              rel='noopener noreferrer'>{item.icon}</a>)
          }
        </div>
      </div>
     

    </header>
  )
}

export default Header